/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Deep_TitleInputs */

const en_to_yaml_deep_title = /** @type {(inputs: To_Yaml_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quoting, and why yes is not a boolean here`)
};

const ko_to_yaml_deep_title = /** @type {(inputs: To_Yaml_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인용, 그리고 여기서 yes가 불리언이 아닌 이유`)
};

const ja_to_yaml_deep_title = /** @type {(inputs: To_Yaml_Deep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`引用、そしてここで yes が真偽値でない理由`)
};

/**
* | output |
* | --- |
* | "Quoting, and why yes is not a boolean here" |
*
* @param {To_Yaml_Deep_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_deep_title = /** @type {((inputs?: To_Yaml_Deep_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Deep_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_deep_title(inputs)
	if (locale === "ko") return ko_to_yaml_deep_title(inputs)
	return ja_to_yaml_deep_title(inputs)
});